import { Subsets } from 'src/app/shared/services/data.service';

export class User {
  id?: number;
  password?: string = '';
  token?: string = '';
  isOTP: boolean = false;
  employee?: {
    id?: string;
    firstName?: string;
    lastName?: string;
    designation?: Subsets;
    mailId?: string;
    baseLocation?: string;
  } = {};
  roleClass?: {
    id?: number;
    roleName?: string;
    code?: string;
    permissionRef?: {
      id?: number;
      employeeAccess?: string;
      projectAccess?: string;
      clientAccess?: string;
      userAccess?: string;
      projectDetailAccess?: string;
      reportAccess?: string;
      code?: string;
      dashboardAccess?: string;
      settingAccess?: string;
      campusAccess?: string;
      approvalAccess?: string;
      vendorAccess?: string;
      expenseAccess?: string;
      helpdeskTicketMgmtAccess?: string;
      helpdeskSRMgmtAccess?: {
        Assigned?: string | null;
        Dashboard?: string | null;
        MySR?: string | null;
        NewSR?: string | null;
      };
      learnDevelopmentAccess: string;
    };
  } = {};
  projectInfo?: ProjectInfo[] = [];
  reportingManager?: { id?: string; firstName?: string; lastName?: string; mailId?:string } =
    {};
  isAdLogin: boolean = false;
  userSpecificPermission:string = '';
}

export class ProjectInfo {
  id?: number;
  name?: string;
}
